import { render } from "./Revenue.vue?vue&type=template&id=7bc8a39e&scoped=true"
import script from "./Revenue.vue?vue&type=script&lang=js"
export * from "./Revenue.vue?vue&type=script&lang=js"

import "./Revenue.vue?vue&type=style&index=0&id=7bc8a39e&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc8a39e"]])

export default __exports__